import {makeAutoObservable} from 'mobx';
import {toast} from 'react-toastify';
import {microlessonsListText} from '../microlessonsListText';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';
import {getErrorFromCode} from '../../../../data/errorCodes';
import MicrolessonsRepository from '../../../../data/repositories/MicrolessonsRepository';
import LoadingModule from '../../../../modules/LoadingModule/LoadingModule';

export const MICROLESSONS_PER_PAGE = 12;

class MicrolessonsListStore {
  private microlessonsRepo = new MicrolessonsRepository();

  private loadingModule = new LoadingModule();

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public async getMicrolessons(
    organizationId: string,
    page: number,
    search?: string,
  ) {
    this.loadingModule.startLoading();
    const result = await this.microlessonsRepo.getMicrolessonsList(
      organizationId,
      page,
      MICROLESSONS_PER_PAGE,
      search,
    );
    this.loadingModule.endLoading();
    if (result.success && result.data) {
      return result.data;
    }
    return {
      pagesCount: 0,
      data: [],
    };
  }

  public async deleteMicrolesson(
    organizationId: string,
    microlessonId: string,
  ) {
    const result = await this.microlessonsRepo.deleteMicrolesson(
      organizationId,
      microlessonId,
    );
    if (result.success) {
      toast.success(microlessonsListText.deleteSuccess, toastConfig);
    } else if (result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
    return result.success;
  }
}

export default MicrolessonsListStore;
